import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AutoplayAction, AutoplayStatus, DatahubEntity } from 'src/interfaces/Datahub';
import ApplicationService from 'src/services/ApplicationService';
import { MessageEventType } from 'src/interfaces/MessageEvent';
import usePlayerParams from '../usePlayerParams';
import {
  SELECTOR_AUTOPLAY_AUTOPLAY_ENABLED,
  SELECTOR_AUTOPLAY_IS_AUTOPLAY_VISIBLE,
  AutoplayActionTypes,
} from '../../store/reducers/autoplay';
import useTracking from '../useTracking';

const useAutoplay = () => {
  const isAutoplayVisible = useSelector(SELECTOR_AUTOPLAY_IS_AUTOPLAY_VISIBLE);
  const enabled = useSelector(SELECTOR_AUTOPLAY_AUTOPLAY_ENABLED);
  const { trackDatahub, trackMessageEvent } = useTracking();
  const playerParams = usePlayerParams();
  const dispatch = useDispatch();

  const showAutoplay = useCallback(() => {
    dispatch({
      type: AutoplayActionTypes.SHOW_AUTOPLAY,
    });
  }, []);

  const hideAutoplay = useCallback(() => {
    dispatch({
      type: AutoplayActionTypes.HIDE_AUTOPLAY,
    });
  }, []);

  const goToNextVideo = useCallback(() => {
    trackMessageEvent(MessageEventType.CHANGEVIDEO);
  }, [trackMessageEvent]);

  const toggleAutoplayEnabled = useCallback(() => {
    dispatch({
      type: AutoplayActionTypes.TOGGLE_AUTOPLAY_ENABLED,
    });

    ApplicationService.userPreferences.updatePreferences({ autoplayEnabled: !enabled });
    trackDatahub(DatahubEntity.AUTOPLAY, AutoplayAction.TOGGLE, {
      status: enabled ? AutoplayStatus.DISABLED : AutoplayStatus.ENABLED,
    });
  }, [enabled]);

  const handleAutoplay = useCallback(() => {
    if (Boolean(playerParams.autonext) === true && enabled) {
      showAutoplay();
    }
  }, [playerParams, enabled]);

  return {
    isAutoplayVisible,
    hideAutoplay,
    showAutoplay,
    handleAutoplay,
    enabled,
    toggleAutoplayEnabled,
    goToNextVideo,
  };
};

export default useAutoplay;
